import React from 'react';

import './basket-item-loading.less';

class BasketItemLoading extends React.Component {
  render() {
    return (
      <div className="basket-item-loading__row">
        <div className="placeholder-box basket-item-loading__icon" />
        <div className="basket-item-loading__content">
          <div className="placeholder-box basket-item-loading__short-desc-line" />
          <div className="placeholder-box basket-item-loading__short-desc-line" />
        </div>
        <div className="placeholder-box basket-item-loading__button" />
      </div>
    );
  }
}
export default BasketItemLoading;



// WEBPACK FOOTER //
// ./spa/Pages/Booking/Basket/BasketItemLoading.jsx